export default __webpack_public_path__ + "static/media/02f9be00acf8b035aee472ce09c6f6dc04ccb05daa1e103683afc38ec50d12b0.f43ebec0.png";